<template>
    <!-- 弹窗 -->
    <el-dialog :title="mode" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
        <div style="">
            <table class="gridtable">
                <tbody>
                <tr>
                    <th colspan="2">项目</th>
                    <th>评分</th>
                </tr>
                <tr>
                    <td colspan="2">基本素质(30分)</td>
                    <td><el-input v-model="pdbForm.basic_quality" type="number" max="30" @blur="change"></el-input></td>
                </tr>
                <tr>
                    <td rowspan="5">经济指标(30分)</td>
                    <td>企业净资产(6分)</td>
                    <td><el-input v-model="pdbForm.net_assets" type="number" @blur="change"></el-input></td>
                </tr>
                <tr>

                    <td>工程结算收入(6分)</td>
                    <td><el-input v-model="pdbForm.project_settle_income" type="number" @blur="change"></el-input></td>
                </tr>
                <tr>

                    <td>净资产增长率(6分)</td>
                    <td><el-input v-model="pdbForm.growth_rate" type="number" @blur="change"></el-input></td>
                </tr>
                <tr>
                    <td>资产负债率(6分)</td>
                    <td><el-input v-model="pdbForm.liability_ratio" type="number" @blur="change"></el-input></td>
                </tr>
                <tr>
                    <td>产值利润率(6分)</td>
                    <td><el-input v-model="pdbForm.profit_rate" type="number" @blur="change"></el-input></td>
                </tr>
                <tr>
                    <td colspan="2">企业管理(40分)</td>
                    <td><el-input v-model="pdbForm.enp_management" type="number" @blur="change"></el-input></td>
                </tr>

                <tr>
                    <td rowspan="2">市场信用（20）</td>
                    <td>优良信息</td>
                    <td><el-input v-model="pdbForm.good_msg" type="number" @blur="change"></el-input></td>
                </tr>

                <tr>
                    <td>-不良信息(负分)</td>
                    <td><el-input v-model="pdbForm.bad_msg" type="number" @blur="change"></el-input></td>
                </tr>
                <tr>
                    <td></td>
                    <td>总计</td>
                    <td><el-input v-model="pdbForm.total" type="number" readonly></el-input></td>
                </tr>

                </tbody>
            </table>

            <div style="margin-top: 10px">
                <span slot="footer" class="dialog-footer" >
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="showScore">保 存</el-button>
                </span>
            </div>

        </div>


    </el-dialog>
</template>

<script>
    import {
        givePoint
    } from '../../../api/moudles/manager.js'
    import {
        client
    } from '@/libs/oss.js'
    export default {

        name:'givePoint',
        data() {
            return {
                mode: '初审打分',
                dialogVisible: false,
                // 模板下载数据
                downloadList: [],
                uploadList: [],
                fileList: [],
                ids:'',
                pdbForm:{
                    basic_quality:'',
                    net_assets:'',
                    project_settle_income:'',
                    growth_rate:'',
                    liability_ratio:'',
                    profit_rate:'',
                    good_msg:'',
                    bad_msg:'',
                    enp_management:'',
                    project_app_num:'',
                    total:'',

                },
            }
        },
        components: {},
        filters: {
            titleFilter(value) {
                if (value.length > 18) {
                    const newVluae = value.split('.')[0].slice(0, 15) + '···.' + value.split('.')[1]
                    return newVluae
                }
                return value
            }
        },
        methods: {

            change(){

                let total = 0;

                console.log(4444343)

                if(this.pdbForm.basic_quality){
                    total +=  parseFloat(this.pdbForm.basic_quality);
                }

                if(this.pdbForm.net_assets){
                    total +=  parseFloat(this.pdbForm.net_assets);
                }

                if(this.pdbForm.project_settle_income){
                    total +=  parseFloat(this.pdbForm.project_settle_income);
                }

                if(this.pdbForm.growth_rate){
                    total +=  parseFloat(this.pdbForm.growth_rate);
                }

                if(this.pdbForm.liability_ratio){
                    total +=  parseFloat(this.pdbForm.liability_ratio);
                }

                if(this.pdbForm.profit_rate){
                    total +=  parseFloat(this.pdbForm.profit_rate);
                }

                if(this.pdbForm.good_msg){
                    total +=  parseFloat(this.pdbForm.good_msg);
                }
                if(this.pdbForm.bad_msg){
                    total +=  parseFloat(this.pdbForm.bad_msg);
                }

                if(this.pdbForm.enp_management){
                    total +=  parseFloat(this.pdbForm.enp_management);
                }

                this.pdbForm.total = total

            },

            // 确认提交
            async showScore() {

                if(this.pdbForm.total == ''){
                    this.$message({
                        message: '总分不能为空',
                        type: 'error'
                    });

                    return
                }

                await givePoint({
                    data: {
                        id: this.ids[0],
                        point: this.pdbForm.total,
                        project_type:4
                    },
                    success: res => {
                        if (res.code === 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            this.dialogVisible = false
                            setTimeout(() => {
                                this.$router.go(-1)
                            }, 1500)
                        } else {
                            this.$message.error(res.msg)
                        }
                    }
                })
            },

            showAdd(type,params) {

                console.log(params)
                this.dialogVisible = true

                this.ids = params.ids

            },
            handleClose() {
                this.dialogVisible = false
            },

        }
    }
</script>

<style scoped="scoped">
    .el-dialog__header {
        height: 100px;
        line-height: 100px;
    }

    .el-dialog__body {
        padding: 10px 20px;
    }

    >>>.el-dialog {
        border-radius: 6px;
    }

    /* 模板下载 */
    .mubanDown {
        display: flex;
        height: 40px;
        line-height: 40px;
        justify-content: space-between;
        align-items: center;
    }

    .mubanDown button {
        cursor: pointer;
        width: 80px;
        height: 35px;
        line-height: 35px;
        border: 1px solid #1890FF;
        font-size: 12px;
        background-color: #ffffff;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #1890FF;
    }

    .innerdialog_list {
        padding-top: 20px;
        display: flex;
        /* height: 40px; */
        align-items: flex-start;
        line-height: 40px;
        align-content: flex-start;
        margin-bottom: 10px;
        border-bottom: 1px solid #B5B5B5;
    }

    /* .innerdialog_list p {

    } */
    .listP {
        font-size: 14px;
        width: 80px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
    }

    .innerdialog_list span {
        display: block;
        font-size: 12px;
        width: 40px;
        margin-left: 20px;
        height: 20px;
        line-height: 20px;
        background: #FFFFFF;
        text-align: center;
        border: 1px solid #1890FF;
        cursor: pointer;
    }

    .list_center {
        width: 310px;
        min-height: 40px;
        display: flex;
        align-content: flex-start;
        flex-wrap: wrap;
    }

    /* 每个上传文件的样式 */
    .inner_upload {
        position: relative;
        height: 40px;
        margin: 0 10px;
        /* width: 100px; */
        /* overflow: scroll; */
    }

    .inner_upload p {
        color: #1890FF;
    }

    .inner_upload img {
        position: absolute;
        right: 0;
        top: 0;
        width: 15px;
        height: 15px;
        cursor: pointer;
    }

    /* 保存提示 */
    .tipList p {
        line-height: 25px;
        text-align: left;
    }

    .tipList p:first-child {
        margin-bottom: 20px;
    }

    /* gridtable */
    table.gridtable {
        font-family: verdana,arial,sans-serif;
        font-size:14px;
        color:#333333;
        border-width: 1px;
        border-color: #666666;
        border-collapse: collapse;
    }
    table.gridtable th {
        border-width: 1px;
        padding: 12px;
        border-style: solid;
        border-color: #666666;
        background-color: #dedede;
    }
    table.gridtable td {
        border-width: 1px;
        padding: 22px;
        border-style: solid;
        border-color: #666666;
        background-color: #ffffff;
    }

    table.gridtable .el-input__inner{
        border: none;
    }

    /* /gridtable */

</style>
